import { AxiosPromise } from "axios";
import { getSite } from "../../hooks/useSite";
import { site } from "../../constants/site";
import { GetPledgInstallmentsApi } from "@hcl-commerce-store-sdk/typescript-axios-transaction";

const PledgInstallmentsApiInstance = new GetPledgInstallmentsApi(undefined, site.transactionContext);

const PledgeInstallmentsService = {
  /**
   * Fetch Pledg Installments
   * @summary Fetch Pledg installments prices for purchase
   * @param {string} storeId The store identifier.
   * @param {PledgInstallmentsBody} body The body data required for the REST method.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GetPledgInstallmentsApi
   */
  getPledgInstallments(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;
    return PledgInstallmentsApiInstance.pledgInstallments(storeId, body, options);
  },
};

export default PledgeInstallmentsService;
